import { createReducer, on } from '@ngrx/store';
import * as fromSelected from '@product-details/store/actions/selected.delivery.date.action';

export interface CalendarState {
  selectedDate: string | null;
}

export const initialState: CalendarState = {
  selectedDate: null,
};

export const calendarReducer = createReducer(
  initialState,
  on(fromSelected.selectDeliveryDate, (state, { selectedDate }) => {
    return {
      ...state,
      selectedDate,
    };
  })
);

export function reducer(
  state: CalendarState | undefined,
  action: fromSelected.SelectedDeliveryDateActions
) {
  return calendarReducer(state, action);
}
